/* owkar-products.js - Products carousel slider for Shopify */

(function() {
  function initProductsCarousels() {
    const sections = document.querySelectorAll('.products-section');
    sections.forEach(section => {
      // Avoid double initialization
      if (section.classList.contains('carousel-initialized')) return;
      
      const track = section.querySelector('.products-carousel-track');
      if (!track || track.classList.contains('layout-grid')) return;
      
      const prevBtn = section.querySelector('.products-nav-btn.prev-btn');
      const nextBtn = section.querySelector('.products-nav-btn.next-btn');
      
      if (!prevBtn || !nextBtn) return;
      
      const cards = track.querySelectorAll('.product-card');
      if (cards.length === 0) return;
      
      let currentIndex = 0;
      
      function getVisibleCardsCount() {
        const width = window.innerWidth;
        const colsDesktop = parseInt(section.dataset.colsDesktop, 10) || 4;
        const colsLaptop = parseInt(section.dataset.colsLaptop, 10) || 3;
        const colsTablet = parseInt(section.dataset.colsTablet, 10) || 2;
        const colsMobile = parseInt(section.dataset.colsMobile, 10) || 1;
        
        if (width > 1024) return colsDesktop;
        if (width > 768) return colsLaptop;
        if (width > 480) return colsTablet;
        return colsMobile;
      }
      
      function getCardWidth() {
        return cards[0].offsetWidth;
      }
      
      function getGap() {
        const computedStyle = window.getComputedStyle(track);
        const gapVal = parseFloat(computedStyle.gap || computedStyle.columnGap);
        if (!isNaN(gapVal)) return gapVal;
        return window.innerWidth > 768 ? 24 : 16;
      }
      
      function getMaxIndex() {
        const visibleCount = getVisibleCardsCount();
        return Math.max(0, cards.length - visibleCount);
      }
      
      function updateCarousel() {
        const maxIndex = getMaxIndex();
        if (currentIndex > maxIndex) {
          currentIndex = maxIndex;
        }
        if (currentIndex < 0) {
          currentIndex = 0;
        }
        
        if (maxIndex <= 0) {
          prevBtn.style.display = 'none';
          nextBtn.style.display = 'none';
          track.style.transform = 'translateX(0px)';
          return;
        } else {
          prevBtn.style.display = '';
          nextBtn.style.display = '';
        }
        
        const cardWidth = getCardWidth();
        const gap = getGap();
        const slideAmount = cardWidth + gap;
        const offset = -currentIndex * slideAmount;
        
        track.style.transform = `translateX(${offset}px)`;
        
        // Disable / Enable buttons based on bounds
        if (currentIndex === 0) {
          prevBtn.style.opacity = '0.3';
          prevBtn.style.pointerEvents = 'none';
        } else {
          prevBtn.style.opacity = '1';
          prevBtn.style.pointerEvents = 'auto';
        }
        
        if (currentIndex >= maxIndex) {
          nextBtn.style.opacity = '0.3';
          nextBtn.style.pointerEvents = 'none';
        } else {
          nextBtn.style.opacity = '1';
          nextBtn.style.pointerEvents = 'auto';
        }
      }
      
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const maxIndex = getMaxIndex();
        if (currentIndex < maxIndex) {
          currentIndex++;
          updateCarousel();
        }
      });
      
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (currentIndex > 0) {
          currentIndex--;
          updateCarousel();
        }
      });

      // Mobile Touch / Swipe Support
      let touchStartX = 0;
      let touchEndX = 0;
      
      track.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      track.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          const maxIndex = getMaxIndex();
          if (diff > 0 && currentIndex < maxIndex) {
            currentIndex++;
            updateCarousel();
          } else if (diff < 0 && currentIndex > 0) {
            currentIndex--;
            updateCarousel();
          }
        }
      }, { passive: true });
      
      window.addEventListener('resize', updateCarousel, { passive: true });
      
      // Initialize after images/layout stabilizes
      setTimeout(updateCarousel, 300);
      
      section.classList.add('carousel-initialized');
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductsCarousels);
  } else {
    initProductsCarousels();
  }
  
  // Hook into Shopify theme editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList && event.target.classList.contains('products-section')) {
      event.target.classList.remove('carousel-initialized');
      initProductsCarousels();
    } else if (event.target.querySelector && event.target.querySelector('.products-section')) {
      const sec = event.target.querySelector('.products-section');
      sec.classList.remove('carousel-initialized');
      initProductsCarousels();
    }
  });
})();
